export default __webpack_public_path__ + "static/media/authereum.32fee7e1.jpeg";